import React, {useContext} from 'react'
import {AppContext} from "../context/app-context";
import {getLandingRedirectPathForUser} from "./route-utils";
import {Navigate} from "react-router";

const UserBasedLandingRedirect: React.FC = () => {
  const appContext = useContext(AppContext)
  const {user} = appContext

  if (!user) {
    return <Navigate to="/login" replace/>
  }

  return (
    <Navigate to={getLandingRedirectPathForUser(user)} replace/>
  )
}

export default UserBasedLandingRedirect
